<div class="root" (click)="matDialogRef.close()" aria-label="Close dialog">
  <p [innerHTML]="get_text_content()"></p>
  <button
    (click)="copyContent($event)"
    style="background-color: #25d366"
    mat-raised-button
    color="warn"
  >
    Whatsapp
  </button>
</div>
